import { render } from "./string-array.vue?vue&type=template&id=7223808c"
import script from "./string-array.vue?vue&type=script&lang=ts"
export * from "./string-array.vue?vue&type=script&lang=ts"
script.render = render

export default script